import { formulaireContactB2bMock, titreDescriptionVideoMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionVideoMock(false), titreDescriptionVideoMock(true), formulaireContactB2bMock];

export const contactB2bMock: SlugPage = {
  ...pageBase({
    title: 'Contact B2b',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
